import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// 启动MSW
async function enableMocking() {
  if (import.meta.env.DEV) {
    console.log('🔧 开发环境，准备启动MSW...')
    try {
      const { worker } = await import('./mocks/browser')
      console.log('📦 MSW模块加载成功')
      
      await worker.start({
        onUnhandledRequest: 'bypass',
        serviceWorker: {
          url: '/mockServiceWorker.js'
        }
      })
      
      console.log('✅ MSW已成功启动并开始拦截API请求')
      console.log('📍 拦截的API路径包括: /api/*')
      
      // 添加一个测试请求来验证MSW是否工作
      try {
        const testResponse = await fetch('/api/talents/specialties')
        const testData = await testResponse.json()
        console.log('🧪 MSW测试请求成功:', testData.success ? '✅' : '❌')
      } catch (testError) {
        console.error('🚨 MSW测试请求失败:', testError)
      }
      
    } catch (error) {
      console.error('❌ MSW启动失败:', error)
      console.error('详细错误信息:', error.stack)
    }
  } else {
    console.log('🏭 生产环境，跳过MSW启动')
  }
}

enableMocking().then(() => {
  console.log('🚀 开始渲染React应用')
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}).catch((error) => {
  console.error('💥 应用启动失败:', error)
}) 